import React from "react";
import {
  Box,
  Heading,
  Text,
  SimpleGrid,
  Image,
  VStack,
  Flex,
  Center,
  Stack,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import solar1 from "../assets/prebid.jpg";
import solar2 from "../assets/detailedengg.jpg";
import designEngg from "../assets/designengg.jpg";
import autocad from "../assets/autocad-logo.png";
import etap from "../assets/etap-logo.png";
import sketchup from "../assets/sketch-logo.png";
import helioscope from "../assets/helioscope-logo.png";
import staadpro from "../assets/staadpro-logo.png";
import excel from "../assets/excel-logo.png";
import pvsyst from "../assets/pvsyst-logo.png";
import generatedCircles from "../assets/designcircles.png";
import solidworks from "../assets/solid-works.png";

const MotionBox = motion(Box);
const MotionFlex = motion(Flex);

export default function ServicesDesign() {
  // Constants
  const preBidStepsColumn1 = [
    { title: "Review of RFQ/RFP documents of client and its details" },
    {
      title:
        "Study, analyze and suggest on technical requirements of the Bid Document",
    },
    { title: "Data collection from client/ Site" },
    { title: "Preliminary concept and design" },
    { title: "BOQ Estimation" },
  ];

  const preBidStepsColumn2 = [
    { title: "Identification of sources of materials" },
    { title: "Estimation of the project cost" },
    { title: "Preparation of Project Schedule" },
    { title: "Preparation of Bid Documents" },
    { title: "Assistance during bid submission and auctions" },
  ];

  const detailedEngineeringCardsLeft = [
    { title: "DC Side Designing" },
    { title: "AC Side Designing" },
    { title: "Electrical Designing" },
    { title: "Communication System Designing" },
  ];

  const detailedEngineeringCardsRight = [
    { title: "Civil & Structural Designing" },
    { title: "Infrastructure Designing" },
    { title: "Transmission Line Designing" },
    { title: "Substation Designing" },
  ];

  const designTools = [
    { name: "AutoCAD", logo: autocad, showName: false,maxImage: false },
    { name: "ETAP", logo: etap, showName: false ,maxImage: false},
    { name: "Helioscope", logo: helioscope, showName: false ,maxImage: true},
    { name: "MS Excel", logo: excel, showName: true ,maxImage: false},
    { name: "PVSyst", logo: pvsyst, showName: false ,maxImage: false},
    { name: "Sketch Up", logo: sketchup, showName: false ,maxImage: false},
    { name: "STAAD Pro", logo: staadpro, showName: true ,maxImage: false},
    { name: "Solid Works", logo: solidworks, showName: false ,maxImage: true},
  ];

  const detailed = [
    {
      frontText: "Detailed Engineering",
      backText:
        "Our engineering experts ensure that project is completely designed in terms of Civil, Mechanical and Electrical aspects.",
    },
    {
      frontText: "Budget Calculation",
      backText:
        "Our procurement department in close association with our engineering experts prepares a comprehensive and accurate Bill of Material, Machinery, Resources, & Statuary Requirements in the Project along with their backed-up costing. This helps in ensuring increased commercial viability of the project.",
    },
    {
      frontText: "Construction Support",
      backText:
        "We work in tandem with the project team of our clients. We ensure that the ground team gets constant support in terms of engineering throughout the project execution phase whenever required. Through this we ensure that project is installed as per the design finalized during detailed engineering phase.",
    },
  ];

  return (
    <Box>
      <Box bg="#F5FAF6" color="#305D24">
        {/* Hero Section */}
        <Box
          position="relative"
          shadow="xl"
          textAlign="center"
          overflow="hidden"
           minH={{ base: "300px", md: "350px" }}  
        >
          <Box
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            bgImage={designEngg}
            bgSize="cover"
            bgPosition="center"
            filter="brightness(0.6) blur(2px)"
            zIndex={0}
          />
          <Box
            position="relative"
            zIndex={1}
            p={{ base: 10, md: 16 }}
            color="white"
          >
            <Heading
              fontSize={{ base: "3xl", md: "5xl" }}
              mb={4}
              textShadow="2px 2px 4px rgba(0,0,0,0.7)"
            >
              Design & Engineering
            </Heading>
            <Text
              fontWeight="bold"
              fontSize={{ base: "md", md: "lg" }}
              mt={4}
              maxW="3xl"
              mx="auto"
              textShadow="1px 1px 3px rgba(0,0,0,0.6)"
            >
              Designing a solar power plant is one of the most critical stages
              of the project which requires technical expertise.
            </Text>
            <Text
              fontWeight="bold"
              mt={2}
              maxW="3xl"
              mx="auto"
              textShadow="1px 1px 3px rgba(0,0,0,0.6)"
            >
              Our dedicated team, equipped with advanced tools, provides
              customized design and engineering services to help clients achieve
              their goals.
            </Text>
          </Box>
        </Box>

        {/* Pre-Bid Engineering Section */}
        <MotionBox
          bg="white"
          rounded="2xl"
          p={5}
          mb={10}
          shadow="xl"
          whileHover={{ scale: 1.01 }}
        >
          <Flex
            align="center"
            direction={{ base: "column", md: "row" }}
            gap={8}
          >
            <Box flex={1}>
              <Heading
                size="lg"
                fontSize={{ base: "2xl", md: "5xl" }}
                mb={4}
                color="#519C36"
              >
                Pre-Bid Engineering
              </Heading>
              <Text>
                With deep expertise in commercial rooftops, MW-Scale plants, and
                net metering, HoriSun team ensures the bidder not only in
                winning the bid but also to execute the project within initial
                estimates.
              </Text>
            </Box>
            <Box flex={1}>
              <Image
                src={solar2}
                alt="Pre-bid Engineering"
                rounded="2xl"
                shadow="md"
                maxH="350px"
                w="100%"
                objectFit="cover"
              />
            </Box>
          </Flex>

          {/* Subheading for Steps */}
          <Heading
            size="md"
            fontSize={{ base: "lg", md: "4xl" }}
            mt={10}
            mb={4}
            color="#305D24"
            textAlign="center"
          >
            Key Stages Before Bid Submission
          </Heading>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} mt={4}>
            {[preBidStepsColumn1, preBidStepsColumn2].map((col, idx) => (
              <VStack spacing={4} align="start" key={idx}>
                {col.map(({ title }, i) => (
                  <MotionBox
                    key={i}
                    bg="#F5FAF6"
                    p={4}
                    rounded="xl"
                    shadow="md"
                    align="center"
                    gap={4}
                    w="100%"
                    display="flex"
                    flexDirection="row"
                    initial={{ opacity: 0, y: 20 }} // start slightly lower
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                      delay: i * 0.15,
                      type: "spring",
                      stiffness: 80,
                    }} // staggered effect
                  >
                    <Box
                      w="12px"
                      h="12px"
                      bg="#519C36"
                      borderRadius="full"
                      flexShrink={0}
                    />
                    <Text fontWeight="semibold" color="#2F4F2F">
                      {title}
                    </Text>
                  </MotionBox>
                ))}
              </VStack>
            ))}
          </SimpleGrid>
        </MotionBox>

        {/* Tools & Software Section */}
        <MotionBox
          bg="#bec9baff"
          rounded="2xl"
          p={{ base: 6, md: 10 }}
          mb={10}
          shadow="xl"
          textAlign="center"
        >
          <Heading
            size="lg"
            mb={6}
            fontSize={{ base: "2xl", md: "5xl" }}
            color="#519C36"
          >
            Tools & Softwares
          </Heading>
          <SimpleGrid columns={{ base: 2, md: 4 }} spacing={10}>
  {designTools.map(({ name, logo, showName, maxImage }, i) => (
    <MotionBox
      key={i}
      whileInView={{ opacity: 1, scale: 1 }}
      initial={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.3, delay: i * 0.1 }}
      bg="#F5FAF6"
      p={6}
      rounded="xl"
      shadow="md"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      _hover={{ transform: "scale(1.1)", shadow: "lg" }}
      minH="150px"
      w="100%" // keep box uniform
    >
      <Image
        src={logo}
        alt={name}
        boxSize={{
          base: maxImage ? "120px" : "80px",
          md: maxImage ? "140px" : "100px",
        }}
        objectFit="contain"
      />
      {showName && (
        <Text
          mt={3}
          fontSize={{ base: "sm", md: "md" }}
          fontWeight="medium"
          color="black"
          textAlign="center"
        >
          {name}
        </Text>
      )}
    </MotionBox>
  ))}
</SimpleGrid>

        </MotionBox>

        {/* Detailed Engineering Section */}
        <MotionBox
          bg="white"
          rounded="2xl"
          p={6}
          mb={10}
          shadow="xl"
          whileHover={{ scale: 1.01 }}
        >
          <Flex
            align="center"
            direction={{ base: "column", md: "row" }}
            gap={8}
          >
            <Box flex={1}>
              <Heading
                size="lg"
                fontSize={{ base: "2xl", md: "5xl" }}
                mb={4}
                color="#519C36"
              >
                Detailed Engineering
              </Heading>
              <Text>
                During detailed engineering phase, conceptual designs are
                converted into technical documents that enable efficient
                procurement and construction execution. HoriSun ensures smooth
                coordination with the engineering department of EPC companies
                and developers.
              </Text>
            </Box>
            <Box flex={1}>
              <Image
                src={solar1}
                alt="Detailed Engineering"
                rounded="2xl"
                shadow="md"
                maxH="350px"
                w="100%"
                objectFit="cover"
              />
            </Box>
          </Flex>

          {/* Subheading for Steps */}
          <Heading
            size="md"
            fontSize={{ base: "lg", md: "4xl" }}
            mt={10}
            mb={4}
            color="#305D24"
            textAlign="center"
          >
            Key Phases of Detailed Engineering
          </Heading>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} mt={4}>
            {[
              ...detailedEngineeringCardsLeft,
              ...detailedEngineeringCardsRight,
            ].map(({ title }, i) => (
              <MotionFlex
                key={i}
                bg="#F5FAF6"
                p={4}
                rounded="xl"
                shadow="md"
                align="center"
                gap={4}
                w="100%"
                initial={{ opacity: 0, y: 20 }} // start slightly lower
                animate={{ opacity: 1, y: 0 }} // move to normal position
                transition={{ delay: i * 0.15, type: "spring", stiffness: 80 }} // staggered animation
              >
                <Box
                  w="12px"
                  h="12px"
                  bg="#519C36"
                  borderRadius="full"
                  flexShrink={0}
                />
                <Text fontWeight="semibold" color="#2F4F2F">
                  {title}
                </Text>
              </MotionFlex>
            ))}
          </SimpleGrid>
        </MotionBox>

        {/* Construction Support Cards */}
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6} mb={10}>
          {detailed.map(({ frontText, backText }, i) => (
            <MotionBox
              key={i}
              whileInView={{ opacity: 1, y: 0 }}
              initial={{ opacity: 0, y: 40 }}
              transition={{ duration: 0.5, delay: i * 0.2 }}
              whileHover={{ scale: 1.05, boxShadow: "lg" }}
              bg="white"
              rounded="2xl"
              p={6}
              shadow="md"
              textAlign="center"
            >
              <Heading size="md" mb={3} color="#519C36">
                {frontText}
              </Heading>
              <Text color="#2F4F2F">{backText}</Text>
            </MotionBox>
          ))}
        </SimpleGrid>

        {/* Why HoriSun Section */}
        <Box textAlign="center">
          <Center>
            <Image
              src={generatedCircles} // replace with your image path
              alt="Benefits with HoriSun Diagram"
              maxW={{ base: "100%", md: "100%" }}
              borderRadius="2xl"
              shadow="xl"
            />
          </Center>
        </Box>

        {/* Call to Action */}
        <Center mt={16}>
          <Box
            as="a"
            href="/contact"
            bg="#F6A11A"
            px={12}
            py={5}
            fontWeight="bold"
            borderRadius="3xl"
            shadow="xl"
            _hover={{
              bg: "#FFD580",
              color: "#305D24",
              transform: "scale(1.05)",
            }}
          >
            Start a Project
          </Box>
        </Center>
      </Box>
    </Box>
  );
}
